//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'SearchNews',
  components: {
    NewsCard: () => import('@/components/common/NewsCard'),
    Button: () => import('@/components/common/Button'),
    HorizontalEntityCard: () => import('@/components/common/HorizontalEntityCard')
  },
  data () {
    return {
      count: 3,
      page: 1
    }
  },
  computed: {
    ...mapGetters({
      news: 'search/news',
      newsMeta: 'search/newsMeta'
    }),
    show () {
      return this?.news?.length > 0 && this?.page < this?.newsMeta?.last_page
    }
  },
  methods: {
    next () {
      this.page += 1
      this.$store.dispatch('search/news', {
        params: {
          resolution: 'micro',
          query: this.$route.query.search,
          page: this.page,
          count: this.count
        }
      })
    }
  }
}
